import { METHOD_GET, METHOD_POST, SERVER_URL } from "../constants/api";
import { headersAuthSendReceiveJson } from "../headers";
import { apiHandleResponse } from "../../util/api";

export const getPrompts = (options) => {
    return fetch(`${SERVER_URL}/api/v1/genai/prompts`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};


export const getPromptCategories = () => {
    return fetch(`${SERVER_URL}/api/v1/genai/prompts/categories`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

export const getPromptVersions = () => {
    return fetch(`${SERVER_URL}/api/v1/genai/prompts/versions`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};